import { OutletState as v } from "@ancon/wildcat-types";
import n from "moment";
import I from "../date/getTimezoneUtcOffsetDifference.mjs";
import S from "../time/getNextTenthMinute.mjs";
import M from "./getSettingsForOrderFormat.mjs";
import N from "./isOutletAcceptingPreOrders.mjs";
import h from "./getOutletTagInformation.mjs";
import D from "./getServiceIntervalsForOrderFormat.mjs";
import F from "./getOutletNextServiceTimeOffset.mjs";
import "../date/createLocalTimezoneMoment.mjs";
import "./constants.mjs";
import "./getOutletCurrentActiveOperatingHour.mjs";
import "./getTimezoneAdjustedServiceInterval.mjs";
import "../time/getTimeSpanParts.mjs";
import "../date/convertToSpecificTimezone.mjs";
import "./getServiceIntervalTimeSpanMoment.mjs";
import "./searchNextOpeningMoment.mjs";
function J(e, t) {
  const s = (e == null ? void 0 : e.state) === v.Opened, r = M(
    t,
    e == null ? void 0 : e.orderFormatSettings
  ), d = (r == null ? void 0 : r.preparationTime) ?? "00:00:00", g = N(
    (e == null ? void 0 : e.orderFormatSettings) || []
  ), T = D(
    t,
    (e == null ? void 0 : e.serviceDateTimes) || []
  ), o = h(
    T,
    s,
    n(),
    n()
  ), x = !s && g && o.openingTime ? o.openingTime : void 0, f = n(), m = n(x), i = (f > m ? f : m).clone(), c = i.utcOffset();
  i.seconds(0).milliseconds(0), i.utcOffset() - c && i.utcOffset(c, !0);
  const p = F(
    t,
    d,
    e == null ? void 0 : e.deliveryIntegrationEnabled
  );
  p > 0 && i.add(p, "minutes");
  const O = S(i) - i.minutes();
  O && i.add(O, "minutes");
  const a = I(
    m,
    i
  );
  return a && i.add(a, "minutes"), i;
}
export {
  J as default
};
